export default {
  methods: {
    //selection对象
    oSelection() {
      let result = ''
      if (window.getSelection) {
        result = window.getSelection()
      } else if (window.document.getSelection) {
        result = window.document.getSelection()
      } else if (window.document.selection) {
        result = window.document.selection.createRange().text
      } else {
        result = ''
      }
      return result
    },
    // 选中文字
    selectText() {
      if (document.selection) {
        return document.selection.createRange().text
      } else {
        return window.getSelection().toString() || ''
      }
    },
    //复制
    copyFn() {
      this.rangeData.text = this.selectText()
      document.execCommand('copy')
    },
    //剪切
    cutFn() {
      this.rangeData.text = this.selectText()
      document.execCommand("cut")
    },
    //粘贴文字
    pasteFn() {
      let range = this.getRange(this.editorContainer)
      let pasteHtml = `<span contenteditable="true">${ this.rangeData.text }</span>`
      this.insertRangeHtml(range, pasteHtml)
    },
    //标记文字
    signTextFn() {
      console.log(111,this.rangeData)
      let text = this.selectText()
      if (!text.length) return alert('请选择文字')
      let obj = this.oSelection()
      let oRange = obj.getRangeAt(0)
      let curEle = {}
      if (window.getSelection) {
        curEle = oRange.commonAncestorContainer.parentElement ? oRange.commonAncestorContainer.parentElement : oRange.commonAncestorContainer.parentNode
      } else {
        curEle = oRange.parentElement()
      }
      //开始检测区域是否能够标记
      if (!(curEle.getAttribute('class') === 'short-answer' || curEle.getAttribute('class') === 'sa-content' || curEle.nodeName.toLowerCase() === 'font')) return
      let reg = new RegExp('[\n,<br>]', 'gm')
      text = text.replace(reg, '<br />')
      let ele = document.createElement("font")
      ele.style.backgroundColor = "yellow"
      ele.innerHTML = text
      oRange.deleteContents()
      oRange.insertNode(ele)
    },
    //取消标记
    cancelSignFn() {
      let text = this.selectText()
      let obj = this.oSelection()
      if (obj.type === 'None') return
      let oRange = obj.getRangeAt(0)
      if (text.length > 0) {
        let regs = new RegExp('[\n,<br>]', 'gm')
        text = text.replace(regs, '<br />')
        let ele = document.createElement("font")
        ele.style.backgroundColor = "white"
        ele.innerHTML = text
        oRange.deleteContents()
        oRange.insertNode(ele)
        this.rangeData.text = "" //  清除选中内容
      }
    },
    //输入法提示
    IMEAlert() {
      this.visibleIME = false
      window.alert('模拟操作系统中输入法不能选择和切换，实际考试中可以选择和切换!')
    },
    // 插入公式到Dom中
    insertWrite(type) {
      //判断是否在编辑区域内
      if (this.editorContainer === null) {
        this.visibleFm = false
        this.$message.warning('请先定位公式插入位置')
        return
      }
      //加入公式模块
      if (!this.currentFormulaID || this.currentFormulaID === '') this.addFormula()
      this.$nextTick(() => {
        try {
          $('#' + this.currentFormulaID)
            .mathquill('focus')
            .mathquill('write', type)
        } catch (e) {
          $("#" + this.currentFormulaID)
            .mathquill('focus')
        }
      })
      this.visibleFm = false
    },
    // 编辑器鼠标抬起事件
    mouseUpFn(e) {
      if(this.timerMouseUP) {
        // this.$emit('setCurrentSmallContentFn')
        clearTimeout(this.timerMouseUP)
      }
      this.timerMouseUP = setTimeout(() => {
        this.$emit('setCurrentSmallContentFn')
      }, 300000);

      let elem = e.srcElement ? e.srcElement : e.target
      let inFormula = false, inContainer = false, inTabContent = false
      while (elem.tagName.toLowerCase() !== 'body') {
        if (elem.id.indexOf('span_formula_') === 0) {
          inFormula = true
          this.currentFormulaID = elem.id
        } else if (elem.tagName.toLowerCase() === 'div') {
          if (elem.getAttribute('contenteditable') === 'true') {
            inContainer = true
            inTabContent = true
            let __elem = $(elem)
            this.editorContainer = __elem
            if (!inFormula) {
              this.getRange(__elem)
            }
          }
          if (elem.id === 'answerArea') {
            inTabContent = true
            break
          }
        }
        elem = elem.parentNode
      }
      // 显示删除矩阵按钮
      $("#btn_DeleteMatrix")[this._inMatrix() ? 'show' : 'hide']()

      if (inFormula && inTabContent) {
        if (this.currentFormulaID != "") {
          //点击区域在tab容器内，且如果焦点是从编辑公式编辑器内出去的，将焦点保持在公式内。
          $('#' + this.currentFormulaID).mathquill('focus')
        } else {
          this.editorContainer && this.editorContainer.focus()
        }
      } else {
        if (!inContainer) {
          this.editorContainer = null
        }
        this.currentFormulaID = ""
      }
    },
    //获取光标
    getRange(area) {
      area.focus()
      return this.getCurrentRange()
    },
    //获取当前光标
    getCurrentRange() {
      let result = '', userSelection = ''
      if (window.getSelection) {
        userSelection = window.getSelection()
        if (userSelection.getRangeAt) {
          if (userSelection.getRangeAt(0) !== undefined) {
            result = userSelection.getRangeAt(0)
          } else {
            return result
          }
        }
      } else if (document.selection) {
        result = userSelection = document.selection.createRange()
      }
      return result
    },
    //是否在矩阵中
    _inMatrix() {
      if (this.currentFormulaID !== '') {
        return false
      }
      let matrix = this._getMatrix()
      return matrix && matrix.size() > 0
    },
    //获取矩阵
    _getMatrix() {
      if (this.editorContainer !== null) {
        let range = this.getRange(this.editorContainer)
        let pe = $(range.startContainer ? range.startContainer.parentElement : range.parentElement())
        if (pe.hasClass('Matrix')) {
          return pe
        } else {
          return pe.parents('div.Matrix')
        }
      }
      return null
    },
    //插入内容
    insertRangeHtml(range, html) {
      if (window.document.selection) {
        range.pasterHTML(html)
      } else {
        let nodes = $(html)
        range.deleteContents()
        for (let i = nodes.length - 1; i >= 0; i--) {
          range.insertNode(nodes[i])
        }
      }
    },
    // 设置为编辑模式
    editable(id) {
      $("#" + id)
        .data("isEditable", true)
        .mathquill('editable')
        .mathquill('focus')
        .find("textarea")
        .css("margin-left", "-99999px")    //将公式用到的一个textarea移出左边，因为在IE下，编辑模式时会出控件句柄。
    },
    // 在光标位置插入一个公式
    addFormula() {
      let range = this.getRange(this.editorContainer)
      // 每个公式都有个随机编号
      let idSeq = new Date().valueOf()
      // 加上一个空格可以使 光标定位到后面
      let html = this.formulaHtml.replace(/\{0\}/ig, idSeq) + '&nbsp;'
      this.insertRangeHtml(range, html)
      this.editorContainer.focus()
      this.currentFormulaID = `span_formula_${ idSeq }`
      // 初始化公式与事件
      this.$nextTick(() => {
        this.editable(this.currentFormulaID)
        $('#span_Temp').remove()
        let bs = $('span.blankSpan')
        bs.after('&nbsp;').remove()
      })
    },
    //插入矩阵到Dom中
    insertMatrix(row, col) {
      //判断是否在编辑区域内
      if (this.editorContainer === null) {
        this.visibleTable = false
        this.$message.warning('请先定位矩阵插入位置。')
        return
      }

      //生成矩阵结构
      let id = `div_Matrix_${ new Date().valueOf() }`
      let html = '<div id="' + id + '" class="Matrix" style="margin:10px 0;width:100%;"><table style="width:100%;border-collapse: collapse;" class="table_Matrix"><tbody>_tr_</tbody></table></div>&nbsp;'
      let trs = ''
      for (let i = 0; i < row; i++) {
        let tds = ''
        for (let j = 0; j < col; j++) {
          tds += '<td style="width: _width_;"><div class="MatrixDiv" contentEditable="true"></div></td>'
        }
        trs += `<tr style="height: 30px;line-height:30px;">${ tds }</tr>`
      }

      html = html.replace(/_tr_/g, trs).replace(/_width_/g, `${ 100 / col }%`)
      //将矩阵插入DOM
      if (this.editorContainer !== null) {
        let range = this.getRange(this.editorContainer)
        if (this.currentFormulaID === '') {
          this.insertRangeHtml(range, '<div id="div_matrix_temp"></div>')
          let temp = $('#div_matrix_temp')
          if (temp.parents('div.MatrixDiv').size() > 0) {
            alert('矩阵不能嵌套在矩阵内。')
            temp.remove()
            return
          } else if (temp.parents('table').size() > 0) {
            alert('此处不可以插入矩阵。')
            temp.remove()
            return
          }
          this.insertRangeHtml(range, html)
          temp.remove()
          this.editorContainer.focus()
          this.$nextTick(() => {
            let body = $(document.body)
            if (!body.data('mousedown')) {
              body.mousedown(function (evt) {
                evt = evt ? evt : (window.event ? window.event : null)
                let elem = $(evt.srcElement ? evt.srcElement : evt.target)
                let inMatrix = elem.hasClass('MatrixDiv') || elem.parents('div.MatrixDiv').size() > 0
                let inQueContent = elem.hasClass('queContent') || elem.parents('div.queContent').size() > 0
                if (inQueContent) {
                  $('div.Matrix:visible').parents('div.queContent').attr('contenteditable', !inMatrix)
                }
              }).data('mousedown', true)
            }
          })
        } else {
          alert('公式内不可以插入矩阵。')
        }
      }
    },
    //删除矩阵
    deleteTable() {
      let confirmStatus = confirm('确定要删除当前矩阵吗？')
      if (confirmStatus) {
        let matrix = this._getMatrix()
        if (matrix) {
          let p = matrix.parents('div.queContent')
          matrix.remove()
          p.attr('contenteditable', true).focus()
          this.editorContainer = null
        }
      }
      this.visibleTable = false
    },
    // 改变窗口大小
    toggleWin(pos) {
      this.frameStatus = true
      if (pos === 'top') {
        this.contentHeight = '600px'
      } else if (pos === 'bottom') {
        this.contentHeight = '10px'
        this.$refs.content.style.padding = '0'
        this.textareaHeight = '400px'
      }
    },
    resetTop() {
      this.frameStatus = false
      this.contentHeight = '300px'
      this.$refs.saInput.style.display = 'block'
      this.$refs.content.style.padding = '3px 3px 3px 10px'
      this.textareaHeight = '150px'
    },
    runCalc() {
      this.$emit('runCalc')
    },
  }
}
